import React from 'react';
import { UniversalEditorContext } from '../context/universal-editor-context';
import { createUniversalEditorFilterId, findModelAndFragmentForPath, } from '../utils';
import { isContentFragment, isContentFragmentArray } from '../../content-types';
import { UeElement } from './ue-element';
export const UeContainer = ({ propertyPath, label, children, as, }) => {
    const ueContext = React.useContext(UniversalEditorContext);
    const { filter, lastProperty } = React.useMemo(() => {
        var _a;
        if (!ueContext.isAuthorMode || !ueContext.isFalconContent) {
            return { filter: '', lastProperty: '' };
        }
        const modelAndFragment = findModelAndFragmentForPath(ueContext.rawCmsContent, propertyPath);
        if (!isContentFragment(modelAndFragment === null || modelAndFragment === void 0 ? void 0 : modelAndFragment.fragment) &&
            !isContentFragmentArray(modelAndFragment === null || modelAndFragment === void 0 ? void 0 : modelAndFragment.fragment)) {
            console.warn(`We could not find a ContentFragment or ContentFragment[] for the propertyPath "${propertyPath}"`);
        }
        return {
            filter: createUniversalEditorFilterId((_a = modelAndFragment === null || modelAndFragment === void 0 ? void 0 : modelAndFragment.parentModel) === null || _a === void 0 ? void 0 : _a.path, modelAndFragment === null || modelAndFragment === void 0 ? void 0 : modelAndFragment.lastPropertyName),
            lastProperty: modelAndFragment === null || modelAndFragment === void 0 ? void 0 : modelAndFragment.lastPropertyName,
        };
    }, [propertyPath, ueContext]);
    return (React.createElement(UeElement, { type: "container", property: lastProperty, label: label, as: as, filter: filter }, children));
};
//# sourceMappingURL=ue-container.js.map